$(document).ready(function () {
  // Initial mount
  mountSubsSlider();
  mountFilterSlider()
});

document.addEventListener('facet:updated', () => {
    mountSubsSlider();
    mountFilterSlider();
  // andere reinitialisaties
});

function mountFilterSlider() {
  var collectionFilterSlider = $(".custom-filter-slider");

  if (collectionFilterSlider.length > 0) {
    // Iterate over each element and initialize the slider
    collectionFilterSlider.each(function (index, element) {
      var filterSlider = new Splide(element, {
        type: "slide",
        perPage: 2,
        gap: 12,
        pagination: false,
        speed: 700,
        perMove: 1,
        drag: true,
        arrows: true,
        fixedWidth: "160px",
        breakpoints: {
          992: {
            perPage: 3,
          },
          767: {
            perPage: 2,
            gap: 10,
          },
        },
      });

      // filterSlider.on("overflow", function (isOverflow) {
      //   if (!isOverflow) {
      //     filterSlider.options = {
      //       arrows: false,
      //       drag: false,
      //     };
      //   }
      // });

      filterSlider.mount();
    });
  }
}

function mountSubsSlider() {
  var collectionSubsSliderElement = $(".collection-subs-slider");

  if (collectionSubsSliderElement.length > 0) {
    // Iterate over each element and initialize the slider
    collectionSubsSliderElement.each(function (index, element) {
      var collectionSubsSlider = new Splide(element, {
        type: "slide",
        perPage: 6,
        gap: 12,
        pagination: false,
        speed: 700,
        perMove: 2,
        drag: true,
        arrows: true,
        fixedWidth: "150px",
        breakpoints: {
          992: {
            perPage: 3,
          },
          767: {
            perPage: 2,
            gap: 10,
          },
        },
      });

      collectionSubsSlider.on("overflow", function (isOverflow) {
        if (!isOverflow) {
          collectionSubsSlider.options = {
            arrows: false,
            drag: false,
          };
        }
      });

      collectionSubsSlider.mount();
    });
  }
}
